document.querySelector(".inline-video-section").style.borderBottom = "0";
